<template>
  <div class="row">
    <div class="col-lg-8 col-md-7">
      <edit-profile-form @showNotification="notifyVue">

      </edit-profile-form>
    </div>
    <div class="col-lg-4 col-md-5">
      <user-card @showNotification="notifyVue">

      </user-card>
    </div>
  </div>
</template>
<script>
  import EditProfileForm from './EditProfileForm.vue'
  import UserCard from './UserCard.vue'

  export default {
    components: {
      EditProfileForm,
      UserCard
    },
    methods: {
      notifyVue(html, color, icon){
        this.$emit(
          'showNotification', html, color, icon
        )   
      }
    },
    mounted(){
      this.$emit('cotentLoading')
    }
  }

</script>
<style>

</style>
